import Image from "next/image";
import Link from "next/link";

import logo from "../../public/images/logo/logo.png";

import Nav from "./Nav";
import { useAppContext } from "@/context/Context";

const MobileMenu = () => {
  const { mobile, setMobile } = useAppContext();

  return (
    <>
      <div className={`popup-mobile-menu ${mobile ? "" : "active"}`}>
        <div className="inner-wrapper">
          <div className="inner-top">
            <div className="content">
              <div className="logo">
                <Link href="/">
                  <Image
                    src={logo}
                    width={137}
                    height={45}
                    alt="Menfis Logo"
                  />
                </Link>
              </div>
              <div className="rbt-btn-close">
                <button
                  className="close-button rbt-round-btn"
                  onClick={() => setMobile(!mobile)}
                >
                  <i className="feather-x"></i>
                </button>
              </div>
            </div>
            <p className="description">
              Colegio Menfis, lugar de aprendizajes significativos
            </p>
            <ul className="navbar-top-left rbt-information-list justify-content-start">
              <li>
                <Link href="mailto:secretary@colegiomenfis.org">
                  <i className="feather-mail"></i>secretary@colegiomenfis.org
                </Link>
              </li>
              <li>
                <Link href="tel:+573103548371">
                  <i className="feather-phone"></i>3103548371
                </Link>
              </li>
            </ul>
          </div>

          <Nav />

          <div className="mobile-menu-bottom">
            <div className="rbt-btn-wrapper mb--20">
              <Link
                className="rbt-btn radius-round btn-sm w-100 mb--20 justify-content-center text-center"
                href="/enrollment"
              >
                <span className="btn-text">Admisiones - 2026</span>
              </Link>
              <Link
                className="rbt-btn btn-border-gradient radius-round btn-sm w-100 mb--20 justify-content-center text-center"
                href="https://familia.mattilda.io/"
                target="_blank"
              >
                <span>Pagos</span>
              </Link>
              <Link
                className="rbt-btn btn-secondary radius-round btn-sm w-100 justify-content-center text-center"
                href="https://colegiomenfis.aule.co/"
                target="_blank"
              >
                <span>Aule.co</span>
              </Link>
            </div>

            <div className="social-share-wrapper">
              <span className="rbt-short-title d-block">Encuéntranos</span>
              <ul className="social-icon social-default transparent-with-border justify-content-start">
                <li>
                  <Link 
                    href="https://www.facebook.com/colmenfischinchina"
                    target="_blank"
                  >
                    <i className="feather-facebook"></i>
                  </Link>
                </li>
                <li>
                  <Link 
                    href="https://www.instagram.com/colegiomenfis"
                    target="_blank"  
                  >
                    <i className="feather-instagram"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
